import React, { useEffect, useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

const FooterOne = () => {
  const navigate = useNavigate();
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showInstallButton, setShowInstallButton] = useState(true);

  // Helper: check if install prompt is supported and on Android
  const isInstallPromptSupported = () =>
    "BeforeInstallPromptEvent" in window &&
    /Android/i.test(navigator.userAgent);

  useEffect(() => {
    const handler = (e) => {
      if (!isInstallPromptSupported()) {
        // console.log("❌ Install prompt not supported on this device");
        return;
      }

      // console.log("📦 beforeinstallprompt event fired");
      e.preventDefault();
      setDeferredPrompt(e);
      setShowInstallButton(true);
    };

    window.addEventListener("beforeinstallprompt", handler);
    // console.log("👀 Waiting for beforeinstallprompt...");

    return () => window.removeEventListener("beforeinstallprompt", handler);
  }, []);

  const handleInstallClick = () => {
    if (!deferredPrompt) {
      alert("PWA installation is not supported on this browser.");
      return;
    }

    deferredPrompt.prompt();
    deferredPrompt.userChoice.then((choiceResult) => {
      if (choiceResult.outcome === "accepted") {
        // console.log("✅ User accepted the install prompt");
      } else {
        // console.log("❌ User dismissed the install prompt");
      }
      setDeferredPrompt(null);
      setShowInstallButton(true);
    });
  };

  return (
    <Container fluid className="bg-dark text-white py-2 mt-auto">
      <Row className="align-items-center text-center text-md-start">
        <Col xs={12} md={4} className="mb-2 mb-md-0">
          <h5 className="m-0">Teeblanka</h5>
        </Col>
        <Col xs={12} md={8}>
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
            <div>
              © 2024 - {new Date().getFullYear()} Teeblanka
            </div>

            <div className="d-flex gap-2 mt-2 mt-md-0 align-items-center flex-wrap justify-content-center">
              {showInstallButton && (
                <Button
                  onClick={handleInstallClick}
                  variant="outline-light"
                  size="sm"
                  className="d-flex align-items-center gap-1 px-3 py-1"
                  style={{ borderRadius: "20px", whiteSpace: "nowrap" }}
                >
                  <i className="bi bi-download"></i> Install App
                </Button>
              )}

              <span
                role="button"
                onClick={() => navigate("/contact-us")}
                className="text-white text-decoration-underline d-none"
              >
                Contact Us
              </span>
              <span
                role="button"
                onClick={() => navigate("/about-us")}
                className="text-white text-decoration-underline"
              >
                About Us
              </span>
              <span
                role="button"
                onClick={() => navigate("/privacy-policy")}
                className="text-white text-decoration-underline"
              >
                Privacy & Policy
              </span>
              <span
                role="button"
                onClick={() => navigate("/refund-policy")}
                className="text-white text-decoration-underline"
              >
                Refund & Return Policy
              </span>

              
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default FooterOne;
